export const APP_NAME = "PrOS.WebApp";
export const DEFAULT_DOCUMENT_TITLE = "Bp Premier Online";
